import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LogService } from './log.service';
import { MessagesService } from './messages.service';
import { CommonService } from './common.service';
import { CacheService } from './cache.service';
import { Observable } from 'rxjs/Observable';
import { tap, catchError } from 'rxjs/operators';
import { PageOption } from '../models/common/pageOption';
import { PageOptionResult } from '../models/common/pageOptionResult';
import { RequestResult } from '../models/common/requestResult';
import { TripPayment } from '../models/trips/trip.payment';
import { TripPaymentFilter } from '../models/trips/trip.payment.filter';
import { ErrorCollection } from '../models/common/errorCollection';
import { CACHE_KEYS } from '../contants/CACHE_KEYS';

@Injectable()
export class TripPaymentService {
  private origin: string = environment.API_BASE_URL;

	constructor(
		private _http: HttpClient,
		private _logService: LogService,
		private _messagesService: MessagesService,
		private _common: CommonService,
		private _cacheService: CacheService
	) { }

	getTripPayment(id: string): Observable<TripPayment> {
		return this._http.get<TripPayment>(`${this.origin}/api/payments/${id}`)
			.pipe(
				tap(x => this.log(`getTripPayment: id=${id}`)),
				catchError(this._logService.handleError<TripPayment>('getTripPayment'))
			);
	}

	search(filter: PageOption<TripPaymentFilter>): Observable<PageOptionResult<TripPayment>> {
		let param = this._common.objectToQueryParam(filter);
		return this._http.get<PageOptionResult<TripPayment>>(`${this.origin}/api/payments/${param}`)
			.pipe(
				tap(x => this.log(`getTripPaymentsList param = ${param}`)),
				catchError(this._logService.handleError<PageOptionResult<TripPayment>>('getTripPaymentsList'))
			);
	}

	addTripPayment(tripPayment: TripPayment): Observable<RequestResult<TripPayment>> {
		return this._http.post<RequestResult<TripPayment>>(`${this.origin}/api/payments`, JSON.stringify(tripPayment))
			.pipe(
				tap(x => {
                    this.log(`addTripPayment: id=${tripPayment.id}`);
                    this._cacheService.remove(CACHE_KEYS.tripSelection);
                }),
				catchError(this._logService.handleError<RequestResult<TripPayment>>('addTripPayment'))
			);
	}

	updateTripPayment(tripPayment: TripPayment): Observable<RequestResult<TripPayment>> {
		return this._http.put<RequestResult<TripPayment>>(`${this.origin}/api/payments/${tripPayment.id}`, JSON.stringify(tripPayment))
			.pipe(
				tap(x => {
                    this.log(`updateTripPayment: id=${tripPayment.id}`);
                    this._cacheService.remove(CACHE_KEYS.tripSelection);
                }),
				catchError(this._logService.handleError<RequestResult<TripPayment>>('updateTripPayment'))
			);
	}

	verifyTripPayment(id: number): Observable<RequestResult<TripPayment>> {
		return this._http.put<RequestResult<TripPayment>>(`${this.origin}/api/payments/${id}/verify`, '')
			.pipe(
				tap(x => this.log(`verifyTripPayment: id=${id}`)),
				catchError(this._logService.handleError<RequestResult<TripPayment>>('verifyTripPayment'))
			);
	}

	deleteTripPayment(id: number): Observable<ErrorCollection> {
		return this._http.delete<ErrorCollection>(`${this.origin}/api/payments/${id}`)
			.pipe(
				tap(x => {
                    this.log(`deleteTripPayment: id=${id}`);
                    this._cacheService.remove(CACHE_KEYS.tripSelection);                
                }),
				catchError(this._logService.handleError<ErrorCollection>('deleteTripPayment'))
			);
	}

	private log(message: string) {
		this._messagesService.add('TripPaymentService: ' + message);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/trip-payment.service.ts